import { render, staticRenderFns } from "./pageView.vue?vue&type=template&id=cae4a198&scoped=true&"
import script from "./pageView.vue?vue&type=script&lang=js&"
export * from "./pageView.vue?vue&type=script&lang=js&"
import style0 from "./pageView.vue?vue&type=style&index=0&id=cae4a198&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae4a198",
  null
  
)

export default component.exports